<script>
    import { COMMON__loading } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import Spinner from "./Spinner.svelte";
</script>

<div class="px-2 flex items-center justify-center text-center text-gray-500">
    <Spinner />
    <span class="inline-block dir-aware-pl-1">{getMessage(COMMON__loading)}</span>
</div>
